// MasterInitializer.jsx
import { useEffect, useRef } from "react";
import { useMasterData } from "./MasterDataContext.jsx";

function MasterInitializer() {
  const { propertyTypesReady,  refreshPropertyTypes,clientTypesReady,refreshClientTypes,   FindAndAddMaster } = useMasterData();
  const hasRun = useRef(false); // ✅ track if effect already ran

  useEffect(() => {
    if (!propertyTypesReady || !clientTypesReady|| hasRun.current) return;

    console.log("now adding master if any");

    FindAndAddMaster({
      masterArray: "propertyTypes",
      tableName: "m_propertytypetags",
      fieldName: "propertytype",
      value: "Projects",
      refreshFunction: refreshPropertyTypes,
    });

    FindAndAddMaster({
      masterArray: "clientTypes",
      tableName: "m_clienttypes",
      fieldName: "clienttype",
      value: "Project Developer",
      refreshFunction: refreshClientTypes,
    });




    
    hasRun.current = true; // ✅ mark as done
  }, [propertyTypesReady, FindAndAddMaster, refreshPropertyTypes]);

  return null;
}

export default MasterInitializer;